/**
 * Spinner — geteiltes Lade-Indikator-Primitive (Sprint UI-D1).
 *
 * Reines SVG, dekorativ (`aria-hidden`) — der umgebende Kontext liefert das
 * Label. `currentColor`-Stroke: die Farbe steuert der Caller via `text-*`.
 * Genutzt von Button (loading-State, size `sm`) und den App-Loading-Fallbacks.
 * Die `animate-spin`-Rotation wird per `prefers-reduced-motion` (styles.css)
 * neutralisiert.
 */
type SpinnerSize = 'sm' | 'md' | 'lg';

const SIZE_PX: Record<SpinnerSize, number> = {
  sm: 16,
  md: 24,
  lg: 36,
};

type SpinnerProps = {
  size?: SpinnerSize;
  className?: string;
};

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const px = SIZE_PX[size];
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={`animate-spin ${className}`.trim()}
    >
      {/* Track-Ring */}
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.2"
      />
      {/* 90°-Bogen — die rotierende Sichel */}
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
